/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./App.css";
import "./Frontend.css";
import "./css/components/users/viewClub.css";
import "./css/components/users/forms.css";
import "./css/components/users/Buttons/buttons.css";
import "./css/components/users/share/share.css";
import "./styles/fonts.js";
import { useSelector, useDispatch } from "react-redux";
import { getUser } from "./action/authActions";
import { useAuth } from "./context/auth";
import roleRoutes from "./routes/index";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Routes from "./routes/index";
import { fetchBannerCategories } from "./action/getBannerCategory";
import { fetchHomeBannerCategories } from "./action/getHomeBannerCategory";
import { fetchGoalCategories } from "./action/getGoalCategory";
import { fetchBannerCarouselData } from "./action/bannerCarouselAction";
import { fetchHomeBannerChooserData } from "./action/homeBannerChooserAction";
import SocketUpdate from "./services/SocketUpdate";
import { fetchFeatures } from "./action/featuresAction";
import { getAllClubsApi } from "./features/allClubs.slice";
import { v4 as uuidv4 } from 'uuid';

function LoadingSkeleton() {
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <div style={{ width: "100%", padding: "1rem", background: "#f0f0f0" }}>
        <Skeleton height={100} style={{ marginBottom: "1rem" }} />
      </div>
    </div>
  );
}

export default function App() {
  const dispatch = useDispatch();
  const device_id = localStorage.getItem("mynetgoals.com-device-id");
  const token = localStorage.getItem("mynetgoals.com-token-admin");
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [loading, setLoading] = useState(true);
  const userToken = localStorage.getItem("mynetgoals.com-token");
  useEffect(() => {
    dispatch(fetchHomeBannerChooserData(userToken));
    if (userToken) {
      dispatch(fetchGoalCategories(userToken));
      dispatch(fetchBannerCarouselData(userToken));
      dispatch(fetchFeatures(userToken));
      // dispatch(getAllClubsApi(userToken));
    }
    if (token) {
      dispatch(fetchGoalCategories(token));
      dispatch(fetchBannerCategories(token));
      dispatch(fetchHomeBannerCategories(token));
    }


  }, [userToken, token]);



  useEffect(()=>{
    if(!device_id){

      const new_device_id = uuidv4();
      localStorage.setItem("mynetgoals.com-device-id", new_device_id);

    }
  })
  return (
    <>
      <SocketUpdate />
      <Routes />
    </>
  );
}
